import React, { useEffect } from "react";
import FunnelGraph from "ikizmet-funnel-graph-js";
import NoData from "../../noData/noData";

const FunnelGraphComponent = (props) => {
  const checkForValues = () => {
    if (props.showGraphWithoutValues) {
      return true;
    }

    return props.values.some((row) => row.some((value) => value !== 0));
  };

  const drawGraph = () => {
    if (!checkForValues()) return;

    let graph = new FunnelGraph({
      container: props.container ? "." + props.container : ".funnel",
      hideSubLabels: props.hideSubLabels,
      gradientDirection: props.gradientDirection,
      subLabelVisibility: props.subLabelVisibility,
      data: {
        labels: props.labels,
        subLabels: props.subLabels,
        colors: props.colors,
        values: props.values,
        rawDataValues: props.rawDataValues,
        percentLabels: props.percentLabels,
        subPercents: props.subPercents,
        averageValues: props.averageValues,
        averageTooltip: props.averageTooltip,
        breakdownRawData: props.breakdownRawData
      },
      displayPercent: true,
      direction: props.direction,
      width: props.width,
      height: props.height
    });

    graph.draw();
  };

  useEffect(() => {
    drawGraph();
  }, []);

  const addClasses = () => {
    let className = props.container || "funnel";

    if (props.averageValues?.length) {
      className += " withAverages";
    }

    return className;
  };

  return (
    <div id={props.id} data-testid={props.id}>
      <div className={addClasses()} />
      {!checkForValues() && <NoData />}
    </div>
  );
};

export default FunnelGraphComponent;
